<template>
  <div class="all">
    <div id="mobile">
      <div class="reload">
        Обновите страницу
      </div>
    </div>
    <div id="desktop">
      <div class="scroll-wrap">
        <div class="whole"></div>
        <loader></loader>
        <video width="1920" height="1080" muted autoplay loop preload id="video">
          <source src="../assets/city2_3.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <div id="container">
          <div class="active" id="click-box"></div>
        </div>

        <gradient width="35"></gradient>
        <div class="gradient-two"></div>

        <img class="logo-text active" src="../assets/greysislogotext.svg" alt="Greysis Logo Text" />
        <ul class="nav">
          <li class="active ful">
            <router-link to="/">Фулфилмент</router-link>
          </li>
          <li class="active call">
            <router-link to="/">Колл-центр</router-link>
          </li>
          <li class="active cons">
            <router-link to="/">Консалтинг</router-link>
          </li>
          <li class="active invest">
            <router-link to="/">Инвесторам</router-link>
          </li>
          <li class="active diff">
            <router-link to="/about">О нас</router-link>
          </li>
          <li class="contacts active diff">
            <router-link to="/contact">контакты</router-link>
          </li>
        </ul>

        <menu-icon></menu-icon>

        <wrap title="" pTag=""></wrap>

        <div class="close-details active"></div>

        <div class="wrap-under">
          <div class="title-wrap2">
            <h1 class="title2"></h1>
            <h1 class="title-num"></h1>
          </div>
          <p></p>
          <router-link to="/">
            <div class="angle enter22 active">Заказать</div>
          </router-link>
        </div>

        <div class="top-social">
          <!-- <socialMedia></socialMedia> -->
        </div>

        <music></music>

        <page-number></page-number>
        <div class="go-to">
          <a>
            <div class="prev active" id="prev"></div>
          </a>
          <a>
            <div class="next active" id="next"></div>
          </a>
        </div>
        <div class="timer"></div>
      </div>
      <!-- ____________________________________Loader________________________________________________ -->
      <div class="welcoming">
        <div class="shadow"></div>

        <!-- SEO -->
        <img class="logo-icon" src="../assets/greysislogoicon.svg" alt="Greysis Logo Icon" />
        <br />
        <img class="logo-text2" src="../assets/greysislogotext.svg" alt="Greysis Logo Text" />

        <h3>
          Интеллектуальные системы <br />
          цифровой экономики будущего
        </h3>

        <a class="enter angle active" id="initial-enter">Войти</a>
        <br>
        <p style="text-align: center; z-index: 289;"><a href="/offerta_ru.php">Публичная оферта</a></p>
        <p style="text-align: center; z-index: 289;"><a href="/policy_ru.php">Политика конфиденциальности</a></p>
    </div>
      </div>

      <!-- _________________________________________More Info___________________________________________ -->

      <div class="scroll-down active"></div>

      <div class="moreInfo">
        <h1 class="info">Информация</h1>
        <div class="grid-cover">
          <div class="grid-info">
            <div class="item item1" id="item1">
              <div class="itemOnePicture itemPicture"></div>
              <p></p>
            </div>
            <div class="item item2" id="item2">
              <div class="itemTwoPicture itemPicture"></div>
              <p></p>
            </div>
            <div class="item item3" id="item3">
              <div class="itemThreePicture itemPicture"></div>
              <p></p>
            </div>
            <div class="item item4" id="item4">
              <div class="itemFourPicture itemPicture"></div>
              <p></p>
            </div>
          </div>
        </div>
        <div class="distorted-text">
          <div class="dis-te">
            <h2></h2>
            <h4></h4>
          </div>
          <div class="distorted-img-corners"></div>
          <div class="distorted-img"></div>
          <div class="bg-grid"></div>
        </div>
        <div>
          <div class="morePages">
            <h1 class="info">
              Вам так же будет <br />
              интересно:
            </h1>
            <div class="more-cover">
              <div class="more-info">
                <div class="more-item more-item1">
                  <div class="distorted-more-corners"></div>
                  <div class="distorted-more-img active"></div>
                  <!-- SEO for titles-->
                  <div class="more-decr">
                    <h1>Фулфилмент</h1>
                    <h6>Полный комплекс услуг в электронной коммерции</h6>
                  </div>
                </div>
                <div class="more-item more-item2">
                  <div class="distorted-more-corners"></div>
                  <div class="distorted-more-img active"></div>
                  <div class="more-decr">
                    <h1>Колл-центр</h1>
                    <h6>Обработка заказов интернет-магазинов</h6>
                  </div>
                </div>
                <div class="more-item more-item3">
                  <div class="distorted-more-corners"></div>
                  <div class="distorted-more-img active"></div>
                  <div class="more-decr">
                    <h1>Консалтинг</h1>
                    <h6>
                      На любой ваш вопрос в электронной коммерции у нас уже есть
                      ответы
                    </h6>
                  </div>
                </div>
                <div class="more-item more-item4">
                  <div class="distorted-more-corners"></div>
                  <div class="distorted-more-img active"></div>
                  <div class="more-decr">
                    <h1>Инвесторам</h1>
                    <h6>
                      Вы крупный поставщик или импортёр продукции широкого
                      спроса, который хочет продавать онлайн?
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <h1 class="info contact-title" id="see-grey">
            Обратиться в <br />
            Greysis:
          </h1>
          <p class="contact-par">
            Идейные соображения высшего порядка, а также рамки и место обучения
            кадров способствует подготовки и реализации позиций, занимаемых
            участниками в отношении поставленных задач.
          </p>

          <div class="mobile-hide">
            <contact-comp></contact-comp>
          </div>
          <footerComp></footerComp>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as THREE from "three";
import $ from "jquery";
import { TimelineMax, gsap, CSSPlugin, CSSRulePlugin } from "gsap/all";
import ScrollMagic from "scrollmagic";
// import "scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js";
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
ScrollMagicPluginGsap(ScrollMagic, TimelineMax);
import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader.js";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";

import music from "../components/audio.vue";
import socialMedia from "../components/social-media.vue";
import pageNumber from "../components/page-number.vue";
import gradient from "../components/gradient.vue";
import menuIcon from "../components/menu.vue";
import wrap from "../components/wrapper.vue";
import loader from "../components/loader.vue";
import contactComp from "../components/contact-comp.vue";
import footerComp from "../components/footer.vue";

export default {
  name: "all",
  data() {
    return {
      cube: null,
      renderer: null,
      scene: null,
      camera: null,
      mov: null,
      particleCount: 20,
      maxParticleCount: 40,
      r: 135,
      rHalf: 135 / 2,

      particlesData: [],
      positions: null,
      colors: null,
      particles: null,
      pointCloud: null,
      particlePositions: null,
      linesMesh: null,
      group: null,
      number: null,
      yeet: false,
      start: true,
      previousRoute: null,
      prevBool: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.previousRoute = from;
      if (
        vm.previousRoute.path == "/contact" ||
        vm.previousRoute.path == "/about"
      ) {
        vm.prevBool = true;

        $(".pace-n").hide();
        $(".welcoming").hide();
        $("#container").fadeIn();
        $(".enter").fadeIn();
        $(".next").fadeIn();
        $(".prev").fadeIn();
        $(".gradient").fadeIn();
        $(".page-number").fadeIn();
        $(".nav").fadeIn();
        $(".menu-icon").fadeIn();
        $(".logo-text").fadeIn();
        if (window.innerWidth < 900) {
          $(".go-down").fadeIn();
        }
      } else {
        vm.prevBool = false;
      }
    });
  },
  components: {
    music,
    socialMedia,
    pageNumber,
    gradient,
    loader,
    menuIcon,
    wrap,
    contactComp,
    footerComp,
  },
  methods: {
    init: function () {
      gsap.registerPlugin(CSSPlugin);
      gsap.registerPlugin(CSSRulePlugin);

      this.scene = new THREE.Scene();
      this.scene.transparent = true;
      this.camera = new THREE.PerspectiveCamera(
        35,
        window.innerWidth / window.innerHeight,
        0.1,
        1800
      );

      window.addEventListener("resize", onWindowResize, false);
      function onWindowResize() {
        load.camera.aspect = window.innerWidth / window.innerHeight;
        load.camera.updateProjectionMatrix();
        load.renderer.setSize(window.innerWidth, window.innerHeight);
      }

      this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
      this.renderer.setClearColor(0x000000, 0);
      this.renderer.setSize(window.innerWidth, window.innerHeight - 5);
      this.renderer.setPixelRatio(window.devicePixelRatio / 1);
      document
        .getElementById("container")
        .appendChild(this.renderer.domElement);
      this.controls = new OrbitControls(this.camera, this.renderer.domElement);
      const loader2 = new FBXLoader();
      let load = this;

      var circle = document.getElementById("circle");
      var radius = circle.r.baseVal.value;
      var circumference = radius * 2 * Math.PI;

      circle.style.strokeDasharray = `${circumference} ${circumference}`;
      circle.style.strokeDashoffset = `${circumference}`;

      function setProgress(percent) {
        const offset = circumference - (percent / 100) * circumference;
        circle.style.strokeDashoffset = offset;
      }

      setProgress(0);

      this.clock = new THREE.Clock();

      loader2.load(
        "all5.fbx",
        function (object) {
          //Tunnel
          for (var tun = 0; tun < 14; tun++) {
            object.children[6].children[
              tun
            ].children[0].material = new THREE.MeshBasicMaterial({
              color: 0xc9c9c9,
              transparent: true,
              opacity: 0.35,
            });
          }

          load.number = load.$route.params.id;

          var keys = { 37: 1, 38: 1, 39: 1, 40: 1 };

          function preventDefault(e) {
            e.preventDefault();
          }

          function preventDefaultForScrollKeys(e) {
            if (keys[e.keyCode]) {
              preventDefault(e);
              return false;
            }
          }

          // modern Chrome requires { passive: false } when adding event
          var supportsPassive = false;
          try {
            window.addEventListener(
              "test",
              null,
              Object.defineProperty({}, "passive", {
                get: function () {
                  supportsPassive = true;
                  return supportsPassive;
                },
              })
            );
          } catch (e) {
            console.log("");
          }

          var wheelOpt = supportsPassive ? { passive: false } : false;
          var wheelEvent =
            "onwheel" in document.createElement("div") ? "wheel" : "mousewheel";

          function disableScroll() {
            window.addEventListener("DOMMouseScroll", preventDefault, false); // older FF
            window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
            window.addEventListener("touchmove", preventDefault, wheelOpt); // mobile
            window.addEventListener(
              "keydown",
              preventDefaultForScrollKeys,
              false
            );
          }
          function enableScroll() {
            window.removeEventListener("DOMMouseScroll", preventDefault, false);
            window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
            window.removeEventListener("touchmove", preventDefault, wheelOpt);
            window.removeEventListener(
              "keydown",
              preventDefaultForScrollKeys,
              false
            );
          }

          function switchPage() {
            setTimeout(function () {
              update(
                array[load.number].pz,
                array[load.number].px,
                array[load.number].py,
                array[load.number].rz,
                array[load.number].rx,
                array[load.number].ry,
                array[load.number].pz2,
                array[load.number].px2,
                array[load.number].py2,
                array[load.number].rz2,
                array[load.number].rx2,
                array[load.number].ry2,
                array[load.number].mpz,
                array[load.number].mpx,
                array[load.number].mpy,
                array[load.number].mpz2,
                array[load.number].mpx2,
                array[load.number].mpy2,
                array[load.number].title,
                array[load.number].subtitle,
                array[load.number].infoTextOne,
                array[load.number].infoTextTwo,
                array[load.number].infoTextThree,
                array[load.number].infoTextFour,
                array[load.number].infoPictureOne,
                array[load.number].infoPictureTwo,
                array[load.number].infoPictureThree,
                array[load.number].infoPictureFour,
                array[load.number].Engtitle,
                array[load.number].descr,
                array[load.number].infoDisPicture
              );
            }, 3000);
          }

          var numbers = {
            ful: {
              pz: 285,
              px: -2230,
              py: 69,
              rz: -0.06,
              rx: -0.15,
              ry: -0.49,
              pz2: 200,
              px2: -2320,
              py2: 250,
              rz2: -0.5,
              rx2: -0.8,
              ry2: -0.55,
              mpz: 285,
              mpx: -2180,
              mpy: 69,
              mpz2: 260,
              mpx2: -2240,
              mpy2: 250,
              title: "Фулфилмент",
              Engtitle: "Fulfillment",
              subtitle:
                "Полный комплекс услуг в электронной коммерции: от оформления заказа покупателем до его получения. Несем ответственность за хранение, доставку и финансы ваших заказов.",
              infoTextOne:
                "Комплексное обслуживание интернет-магазинов в Узбекистане",
              infoTextTwo: "Отслеживание заказов в реальном времени",
              infoTextThree:
                "Гарантия безопасности товара, денежных средств и качества доставки",
              infoTextFour: "Индивидуальный подход для каждого клиента",
              infoPictureOne: require("../assets/fulOne.svg"),
              infoPictureTwo: require("../assets/fulTwo.svg"),
              infoPictureThree: require("../assets/fulThree.svg"),
              infoPictureFour: require("../assets/fulFour.svg"),
              descr:
                "— комплекс операций выполняемых Greysis c момента консультирования заказа нашим колл-центром, осуществлением доставки и принятия оплаты у покупателя",
              infoDisPicture: require("../assets/ful-dis.png"),
            },
            call: {
              pz: 400,
              px: -1300,
              py: 70,
              rz: 0,
              rx: 0,
              ry: -0.3,
              pz2: 440,
              px2: -1250,
              py2: 200,
              rz2: -0,
              rx2: -0.5,
              ry2: 0,
              mpz: 400,
              mpx: -1240,
              mpy: 70,
              mpz2: 440,
              mpx2: -1180,
              mpy2: 200,
              title: "Колл-центр",
              Engtitle: "Call-center",
              subtitle:
                "Эксперты в области продаж гарантируют качественную работу с клиентами Вашего интернет-магазина.",
              infoTextOne: "Высокая квалификация операторов",
              infoTextTwo: "Запись всех разговоров и полная отчетность",
              infoTextThree: "Консультируем на русском, узбекском и таджикском",
              infoTextFour:
                "Первый вызов совершается в течении 15 минут с момента оформления заказа",
              infoPictureOne: require("../assets/callOne.svg"),
              infoPictureTwo: require("../assets/callTwo.svg"),
              infoPictureThree: require("../assets/callThree.svg"),
              infoPictureFour: require("../assets/callFour.svg"),
              descr:
                "– подразделение в компании, которое направлено на обработку входящих и исходящих вызовов",
              infoDisPicture: require("../assets/call-dis.png"),
            },
            cons: {
              pz: -20,
              px: -630,
              py: 200,
              rz: -0.3,
              rx: -0.7,
              ry: -0.6,
              pz2: -120,
              px2: -480,
              py2: 200,
              rz2: -0.75,
              rx2: -1.5,
              ry2: -0,
              mpz: -20,
              mpx: -570,
              mpy: 200,
              mpz2: -110,
              mpx2: -460,
              mpy2: 200,
              title: "Консалтинг",
              Engtitle: "Consulting",
              subtitle:
                "На любой ваш вопрос в электронной коммерции у нас уже есть ответы. Мы создали то, в чём сами нуждались. Теперь это доступно и вам.",
              infoTextOne: "Техническая поддержка цифровой экономики бизнеса",
              infoTextTwo:
                "Внедрение систем аналитики, статистики и отчётности",
              infoTextThree: "Содействие в юридических вопросах",
              infoTextFour: "Обучение электронной коммерции",
              infoPictureOne: require("../assets/consOne.svg"),
              infoPictureTwo: require("../assets/consTwo.svg"),
              infoPictureThree: require("../assets/consThree.svg"),
              infoPictureFour: require("../assets/consFour.svg"),
              descr:
                "– экспертный анализ деятельности компании по экономическим, производственным и коммерческим аспектам для оптимизации бизнес-процессов, повышения эффективности и увеличения прибыли",
              infoDisPicture: require("../assets/cans-dis.png"),
            },
            invest: {
              pz: 400,
              px: -85,
              py: 85,
              rz: 0,
              rx: -0.1,
              ry: -0.1,
              pz2: 300,
              px2: -200,
              py2: 270,
              rz2: -0.3,
              rx2: -0.8,
              ry2: -0.3,
              mpz: 400,
              mpx: -45,
              mpy: 85,
              mpz2: 350,
              mpx2: -150,
              mpy2: 270,
              title: "Инвесторам",
              Engtitle: "Investors",
              subtitle:
                "Вы крупный поставщик или импортёр продукции широкого спроса, который хочет продавать онлайн? Оставьте заявку и мы найдём с вами общие интересы для сотрудничества.",
              infoTextOne:
                "Персональные условия импортёрам, производителям и поставщикам",
              infoTextTwo:
                "Предоставление прозрачной отчетности и мониторинг процессов в реальном времени",
              infoTextThree: "Реализация совместных проектов",
              infoTextFour:
                "Гарантия полного возврата инвестиций при любых обстоятельствах",
              infoPictureOne: require("../assets/investOne.svg"),
              infoPictureTwo: require("../assets/investTwo.svg"),
              infoPictureThree: require("../assets/investThree.svg"),
              infoPictureFour: require("../assets/investFour.svg"),
              descr:
                "– Идейные соображения высшего порядка, а также рамки и место обучения кадров способствует подготовки и реализации позиций, занимаемых участниками в отношении поставленных задач.",
              infoDisPicture: require("../assets/invest-dis.png"),
            },
          };

          var array = [];

          for (var key in numbers) {
            array.push(numbers[key]);
          }

          var t = new TimelineMax();

          function update(
            pz,
            px,
            py,
            rz,
            rx,
            ry,
            pz2,
            px2,
            py2,
            rz2,
            rx2,
            ry2,
            mpz,
            mpx,
            mpy,
            mpz2,
            mpx2,
            mpy2,
            title,
            subtitle,
            infoTextOne,
            infoTextTwo,
            infoTextThree,
            infoTextFour,
            infoPictureOne,
            infoPictureTwo,
            infoPictureThree,
            infoPictureFour,
            Engtitle,
            descr,
            infoDisPicture
          ) {
            if ($(window).width() < 900) {
              $("#container").css("height", "50vh");

              $(".top-social").hide();

              $(".audio").hide();

              load.camera = new THREE.PerspectiveCamera(
                35,
                window.innerWidth / (window.innerHeight / 2),
                0.1,
                1800
              );
              load.renderer.setSize(window.innerWidth, window.innerHeight / 2);
              load.renderer.setPixelRatio(window.devicePixelRatio);
            }

            disableScroll();

            $(".gradient").css("width", "35vw");

            $(".wrap-under").css("top", "150vh");
            $(".wrap-under").css("left", "20%");
            $(".wrap-under p").css("transform", "translateY(400%)");
            $(".enter22").css("transform", "translateY(600%)");

            var controller = new ScrollMagic.Controller();

            var t2 = new TimelineMax();
            t2.fromTo(
              ".info",
              { autoAlpha: 0, translateY: "20%" },
              { autoAlpha: 1, translateY: "0%", duration: 1 }
            );
            t2.fromTo(
              "#item1",
              { autoAlpha: 0, translateY: "30%" },
              { delay: 0.1, autoAlpha: 1, translateY: "0%", duration: 1 },
              0
            );
            t2.fromTo(
              "#item2",
              { autoAlpha: 0 },
              { delay: 0.3, autoAlpha: 1, translateY: "50%", duration: 1 },
              0
            );
            t2.fromTo(
              "#item3",
              { autoAlpha: 0, translateY: "20%" },
              { delay: 0.5, autoAlpha: 1, translateY: "0%", duration: 1 },
              0
            );
            t2.fromTo(
              "#item4",
              { autoAlpha: 0, translateY: "70%" },
              { delay: 0.7, autoAlpha: 1, translateY: "50%", duration: 1 },
              0
            );
            // }

            function firstSlide(num) {
              new ScrollMagic.Scene({
                triggerElement: ".moreInfo",
                offset: num,
              })
                .setTween(t2)
                .addTo(controller);
            }
            if (window.innerWidth < 900) {
              firstSlide(-100);
            } else {
              firstSlide(-75);
            }

            var t3 = new TimelineMax();
            if (window.innerWidth < 900) {
            } else {
              t3.fromTo(
                ".dis-te",
                { bottom: "20%" },
                { bottom: "10%", duration: 1, ease: "Power1.easeInOut" }
              );
            }

            var scene2 = new ScrollMagic.Scene({
              triggerElement: ".distorted-text",
              offset: 100,
            })
              .setTween(t3)
              .addTo(controller);

            var t4 = new TimelineMax();
            t4.fromTo(
              ".more-item1",
              { autoAlpha: 0, y: "30%" },
              {
                delay: 0.1,
                autoAlpha: 1,
                y: "0%",
                duration: 0.5,
                ease: "Power1.easeInOut",
              },
              0
            );
            t4.fromTo(
              ".more-item2",
              { autoAlpha: 0, y: "30%" },
              {
                delay: 0.2,
                autoAlpha: 1,
                y: "0%",
                duration: 0.5,
                ease: "Power1.easeInOut",
              },
              0
            );
            t4.fromTo(
              ".more-item3",
              { autoAlpha: 0, y: "30%" },
              {
                delay: 0.3,
                autoAlpha: 1,
                y: "0%",
                duration: 0.5,
                ease: "Power1.easeInOut",
              },
              0
            );
            t4.fromTo(
              ".more-item4",
              { autoAlpha: 0, y: "30%" },
              {
                delay: 0.4,
                autoAlpha: 1,
                y: "0%",
                duration: 0.5,
                ease: "Power1.easeInOut",
              },
              0
            );

            t4.fromTo(
              ".more-item1 .more-decr",
              { autoAlpha: 0, y: "60%" },
              {
                delay: 0.1,
                autoAlpha: 1,
                y: "0%",
                duration: 0.5,
                ease: "Power1.easeInOut",
              },
              0
            );
            t4.fromTo(
              ".more-item2 .more-decr",
              { autoAlpha: 0, y: "60%" },
              {
                delay: 0.2,
                autoAlpha: 1,
                y: "0%",
                duration: 0.5,
                ease: "Power1.easeInOut",
              },
              0
            );
            t4.fromTo(
              ".more-item3 .more-decr",
              { autoAlpha: 0, y: "60%" },
              {
                delay: 0.3,
                autoAlpha: 1,
                y: "0%",
                duration: 0.5,
                ease: "Power1.easeInOut",
              },
              0
            );
            t4.fromTo(
              ".more-item4 .more-decr",
              { autoAlpha: 0, y: "60%" },
              {
                delay: 0.4,
                autoAlpha: 1,
                y: "0%",
                duration: 0.5,
                ease: "Power1.easeInOut",
              },
              0
            );

            function thirdSlide(num) {
              new ScrollMagic.Scene({
                triggerElement: ".morePages",
                offset: num,
              })
                .setTween(t4)
                .addTo(controller);
            }
            if (window.innerWidth < 900) {
              thirdSlide(0);
            } else {
              thirdSlide(50);
            }

            controller.addScene([
              // sceneS,
              scene2,
            ]);

            $(".whole").show();
            $(".moreInfo").show();

            $(".title").html(title);
            $(".wrapper p").html(subtitle);
            $(".title2").html(title);
            $(".wrap-under p").html(subtitle);

            $(".item1 p").html(infoTextOne);
            $(".item2 p").html(infoTextTwo);
            $(".item3 p").html(infoTextThree);
            $(".item4 p").html(infoTextFour);
            $(".dis-te h2").html(Engtitle);
            $(".dis-te h4").html(descr);

            $(".itemOnePicture").css(
              "background-image",
              "url(" + infoPictureOne + ")"
            );
            $(".itemTwoPicture").css(
              "background-image",
              "url(" + infoPictureTwo + ")"
            );
            $(".itemThreePicture").css(
              "background-image",
              "url(" + infoPictureThree + ")"
            );
            $(".itemFourPicture").css(
              "background-image",
              "url(" + infoPictureFour + ")"
            );
            $(".distorted-img").css(
              "background-image",
              "url(" + infoDisPicture + ")"
            );

            load.yeet = true;

            var cover = new TimelineMax();
            if ($(window).width() < 900) {
              cover.set(".wrapper", { overflow: "hidden", top: "75%" });
            } else {
              cover.set(".wrapper", { overflow: "hidden", top: "50%" });
            }
            cover.set(".cover", { width: "0%" });
            cover.set(".title", { alpha: 0 });
            cover.set(".wrapper p", { translateY: "100vh" });
            cover.set(".enter", { translateY: "100vh" });
            cover.to(".cover", 1, { delay: 1, width: "100%" });
            cover.to(".title", 0.1, { alpha: 1 });
            cover.to(".cover", 1, { width: "10px", right: "unset", left: 0 });
            cover.to(".wrapper p, .enter", 1, { translateY: "0px" });
            cover.set(".wrapper", { overflow: "visible" });
            var width = new TimelineMax();
            width.set(".timer", { width: "25vw" });
            width.to(".timer", 3, { width: "50vw", ease: "Power0.easeIn" });
            width.to(".timer", 0.5, { opacity: 0 });

            load.camera.position.x = -750;
            load.camera.position.z = 600;
            load.camera.position.y = 250;
            load.camera.rotation.y = 0;
            load.camera.rotation.z = 0;
            load.camera.rotation.x = -1.5;

            var tl = new TimelineMax();
            tl.set(load.camera.position, { z: 800, x: -750, y: 250 });
            tl.set(load.camera.rotation, { z: 0, x: -1.5, y: 0 });
            if (window.innerWidth < 900) {
              tl.to(
                load.camera.position,
                2,
                { delay: 1, z: mpz, x: mpx, y: mpy, ease: "Power1.easeInOut" },
                0
              );
            } else {
              tl.to(
                load.camera.position,
                2,
                { delay: 1, z: pz, x: px, y: py, ease: "Power1.easeInOut" },
                0
              );
            }
            tl.to(
              load.camera.rotation,
              1,
              {
                delay: 2,
                z: rz,
                x: rx,
                y: ry,
                onComplete: function () {
                  if (load.number == 2) {
                    gridHelper.material.opacity = 0;
                  }

                  if (window.innerWidth > 900) {
                    document.onmousemove = function (event) {
                      var x = (event.clientX * 10) / window.innerWidth;
                      var y = (event.clientY * 10) / window.innerHeight;

                      if (
                        (load.number == 3 && load.camera.position.z == pz) ||
                        (load.number == 2 && load.camera.position.z == pz) ||
                        (load.number == 1 && load.camera.position.z == pz) ||
                        (load.number == 0 && load.camera.position.z == pz)
                      ) {
                        var came = new TimelineMax();
                        came.to("#container", 2, { x: x, y: y });
                      }

                      if (load.number == 3) {
                        var movi = new TimelineMax();
                        var xs = (event.clientX - window.innerWidth / 1.5) / 5; //back
                        var xy = (event.clientY - window.innerHeight / 1.5) / 5; //back

                        var xs1 = (event.clientX - window.innerWidth / 1.5) / 2; //front
                        var xy1 =
                          (event.clientY - window.innerHeight / 1.5) / 2; //front

                        movi.to(
                          object.children[1].children[4].rotation,
                          5,
                          { y: (-xs + -xy) / 450 + 0.3 },
                          0
                        );
                        movi.to(
                          object.children[1].children[3].rotation,
                          5,
                          { y: (xs1 + xy1) / 750 + 0.8 },
                          0
                        );
                      } else if (load.number == 2) {
                        var twoload = setInterval(function () {
                          if (
                            object.children[4].children[0].children[0].position
                              .x == -0.1
                          ) {
                            setProgress(0);
                            document.onmousemove = function (event) {
                              load.mov = new TimelineMax();
                              if (load.camera.position.x == -480) {
                                load.mov.to(
                                  object.children[4].position,
                                  2,
                                  { x: -440, z: -130 },
                                  0
                                );
                              } else {
                                var xs =
                                  (event.clientX - window.innerWidth / 1.5) / 5;
                                var xr =
                                  (event.clientY - window.innerHeight / 1.5) /
                                  5;
                                load.mov.to(
                                  object.children[4].position,
                                  2,
                                  { x: -430 + xs, z: -150 + xr },
                                  0
                                );
                                load.mov.to(
                                  object.children[4].rotation,
                                  2,
                                  { z: xs / 250 - 0.1, x: xr / 350 },
                                  0
                                );
                              }
                            };
                            $("#click-box").hide();
                            clearInterval(twoload);
                          }
                        }, 500);
                      } else if (load.number == 1) {
                        var mov3 = new TimelineMax();
                        var xs3 = (event.clientX - window.innerWidth / 1.5) / 5;
                        var xy3 =
                          (event.clientY - window.innerHeight / 1.5) / 5;

                        mov3.to(
                          object.children[2].children[0].children[1].rotation,
                          5,
                          { y: (xs3 + xy3) / 550 + 0.3 },
                          0
                        );
                      }
                    };
                  }
                },
              },
              0
            );

            function scrollAnim() {
              var time1 = 1;
              var time2 = time1 + 0.5;

              t.clear();

              t.set(".close-details", { display: "none", alpha: 0 }, 0);
              t.set(".menu-icon", { display: "block", alpha: 1 }, 0);

              if (window.innerWidth < 900) {
                t.fromTo(
                  load.camera.position,
                  time1,
                  { z: mpz, x: mpx, y: mpy },
                  { z: mpz2, x: mpx2, y: mpy2, ease: "Power1.easeInOut" },
                  0
                );
              } else {
                t.fromTo(
                  load.camera.position,
                  time1,
                  { z: pz, x: px, y: py },
                  { z: pz2, x: px2, y: py2, ease: "Power1.easeInOut" },
                  0
                );
              }
              t.fromTo(
                load.camera.rotation,
                time1,
                { z: rz, x: rx, y: ry },
                { z: rz2, x: rx2, y: ry2, ease: "Power1.easeInOut" },
                0
              );

              if (load.number == 2) {
                console.log(object.children[4].position)
                t.to(gridHelper.material, time1, { opacity: 0.35 }, 0);
                load.mov = new TimelineMax();
                load.mov.to(
                  object.children[4].position,
                  2,
                  { x: -440, z: -130 },
                  0
                );
                load.mov.to(object.children[4].rotation, 2, { x: 0, z: 0 }, 0);
              }

              t.to(
                ".gradient",
                time1,
                {
                  width: "70vw",
                },
                0
              );
              if ($(window).width() < 900) {
                t.to(".wrap-under", time2, { top: "75vh" }, 0);
              } else {
                t.to(".wrap-under", time2, { top: "50vh" }, 0);
              }
              t.to(".wrap-under p", time1, { translateY: "0" }, 0);
              t.to(
                ".enter22",
                time1,
                {
                  display: "block",
                  translateY: "0",
                  onComplete: function () {
                    enableScroll();
                  },
                },
                0
              );
              t.to(
                ".wrapper",
                time1,
                {
                  top: "-30%",
                },
                0
              );
              t.to(".close-details", time1, { display: "block", alpha: 1 }, 0);
              t.to(".scroll-down", time1, { display: "block", alpha: 1 }, 0);

              $(".scroll-down").click(function () {
                $("html, body").animate(
                  { scrollTop: window.innerHeight },
                  "slow"
                );
              });

              //remove
              t.to(".menu-icon", time1, { display: "none", alpha: 0 }, 0);
              t.to(".nav", time1, { display: "none", alpha: 0 }, 0);
              t.to(".prev", time1, { display: "none", alpha: 0 }, 0);
              t.to(".next", time1, { display: "none", alpha: 0 }, 0);
              t.to(".page-number", time1, { display: "none", alpha: 0 }, 0);
              t.to(".top-social", time1, { display: "none", alpha: 0 }, 0);

              t.play();

              if (load.number == 2) {
                t.to(
                  "video",
                  1,
                  {
                    opacity: 0,
                  },
                  0
                );
              }

              $("#click-box").hide();
            }

            function workOnScr() {
              $("#go-lower").click(function () {
                scrollAnim();
              });

              $(".enter22").click(function () {
                $("html, body").animate(
                  { scrollTop: $("#see-grey").offset().top - 80 },
                  "slow"
                );
              });

              $(".go-down").click(function () {
                scrollAnim();
              });

              $(".close-details").click(function () {
                t.reverse();
                disableScroll();
                $(".menu-icon").fadeIn();
                $("#click-box").show();
              });
            }

            workOnScr();

            //bottomLine

            //Floor

            var size = 4500;
            var divisions = 100;

            var gridHelper = new THREE.GridHelper(size, divisions, 0x888888);
            gridHelper.position.y = 0;
            gridHelper.position.z = 125;
            gridHelper.position.x = -165;

            gridHelper.material.color.set(new THREE.Color(0x2778f3));
            gridHelper.material.opacity = 1;
            gridHelper.material.transparent = true;

            setTimeout(function () {
              gridHelper.material.color.set(new THREE.Color(0x888888));
              gridHelper.material.opacity = 0.5;
            }, 1000);

            load.scene.add(gridHelper);

            //Page1
            object.children[3].children[0].children[0].children[0].children[0].children[0].material = new THREE.MeshBasicMaterial(
              { color: 0x00c2ff }
            ); //Drone1
            object.children[3].children[0].children[1].children[1].children[0].children[0].material = new THREE.MeshBasicMaterial(
              { color: 0xacf8ff, transparent: true, opacity: 0.7 }
            ); //Cube Wires
            object.children[3].children[0].children[1].children[0].material = new THREE.MeshBasicMaterial(
              { color: 0xacf8ff, transparent: true, opacity: 0.1 }
            ); //Cube Inside
            object.children[3].children[1].children[0].children[0].material = new THREE.MeshBasicMaterial(
              { color: 0x00c2ff }
            ); //Cube Inside

            var map = new THREE.TextureLoader().load("fulfilment2.png");
            var photomat = new THREE.SpriteMaterial({
              map: map,
              color: 0xffffff,
            });
            var sprite = new THREE.Sprite(photomat);
            sprite.position.set(-1300, -30, -1200);
            sprite.scale.set(2048, 1024, 1);
            sprite.material.transparent = true;
            sprite.material.opacity = 0.4;

            // 1st Page Boxes
            function boxes(
              size,
              hsize,
              posx,
              posy,
              posz,
              colorW,
              boxColor,
              opac
            ) {
              var boxg = new THREE.BoxGeometry(size, size, size);
              var boxm = new THREE.MeshBasicMaterial({
                color: boxColor,
                transparent: true,
                opacity: opac,
              });
              var name = new THREE.Mesh(boxg, boxm);
              load.scene.add(name);

              var boxg2 = new THREE.EdgesGeometry(boxg);
              var boxm2 = new THREE.LineBasicMaterial({
                color: colorW,
                linewidth: 2,
              });
              var wf = new THREE.LineSegments(boxg2, boxm2);

              name.add(wf);

              var linem = new THREE.LineBasicMaterial({
                color: colorW,
              });

              var pnts = [];
              pnts.push(new THREE.Vector3(0, -hsize, -hsize)); //x,y,z
              pnts.push(new THREE.Vector3(0, hsize, -hsize));
              pnts.push(new THREE.Vector3(0, hsize, hsize));
              pnts.push(new THREE.Vector3(0, -hsize, hsize));
              pnts.push(new THREE.Vector3(0, -hsize, -hsize));
              pnts.push(new THREE.Vector3(0, 0, -hsize));
              pnts.push(new THREE.Vector3(-hsize, 0, -hsize));
              pnts.push(new THREE.Vector3(-hsize, 0, hsize));
              pnts.push(new THREE.Vector3(hsize, 0, hsize));
              pnts.push(new THREE.Vector3(hsize, 0, -hsize));
              pnts.push(new THREE.Vector3(0, 0, -hsize));
              pnts.push(new THREE.Vector3(0, -hsize, -hsize));
              pnts.push(new THREE.Vector3(0, 0, -hsize));
              pnts.push(new THREE.Vector3(hsize, 0, -hsize));
              pnts.push(new THREE.Vector3(hsize, -hsize, -hsize));
              pnts.push(new THREE.Vector3(-hsize, -hsize, hsize));
              pnts.push(new THREE.Vector3(hsize, -hsize, hsize));
              pnts.push(new THREE.Vector3(-hsize, -hsize, -hsize));

              var lineg = new THREE.BufferGeometry().setFromPoints(pnts);

              var line = new THREE.Line(lineg, linem);
              name.add(line);
              name.position.x = posx;
              name.position.z = posz;
              name.position.y = posy;
            }

            boxes(50, 25, -2090, 10, -40, 0x8b8b8b, 0xffffff, 0); //size,hsize,posx,posy,posz,wireframeColor,boxColor,opac
            boxes(25, 12.5, -2035, -10, -110, 0x8b8b8b, 0xffffff, 0);
            boxes(25, 12.5, -1930, -10, 0, 0x8b8b8b, 0xffffff, 0);
            boxes(25, 12.5, -1880, -10, 0, 0x8b8b8b, 0xffffff, 0);
            boxes(25, 12.5, -1880, 15, 0, 0x8b8b8b, 0xffffff, 0);

            //Page2
            object.children[2].children[1].children[0].children[0].material = new THREE.MeshBasicMaterial(
              { color: 0xc9c9c9, transparent: true, opacity: 0.7 }
            ); //2nd Face
            object.children[2].children[8].children[0].children[0].material = new THREE.MeshBasicMaterial(
              { color: 0xc9c9c9, transparent: true, opacity: 0.7 }
            ); //Ring under 2nd Face
            object.children[2].children[0].children[0].children[0].material = new THREE.MeshBasicMaterial(
              { color: 0x00c2ff }
            ); //Particles
            object.children[2].children[0].children[1].children[0].children[0].children[0].material = new THREE.MeshBasicMaterial(
              { color: 0xc9c9c9, transparent: true, opacity: 0.22 }
            ); //mic
            object.children[2].children[0].children[1].children[2].children[0].children[0].material = new THREE.MeshBasicMaterial(
              { color: 0x00c2ff, transparent: true, opacity: 0.7 }
            ); //face
            object.children[2].children[9].children[0].children[0].material = new THREE.MeshBasicMaterial(
              { color: 0x00c2ff }
            ); //Small Line
            object.children[2].children[6].children[0].children[0].material = new THREE.MeshBasicMaterial(
              { color: 0xc9c9c9, transparent: true, opacity: 0.7 }
            ); //Big Line
            object.children[2].children[10].children[0].children[0].material = new THREE.MeshBasicMaterial(
              { color: 0xc9c9c9 }
            ); //2nd Mic
            object.children[2].children[10].children[1].children[0].material = new THREE.MeshBasicMaterial(
              { color: 0xc9c9c9 }
            ); //2nd Mic
            object.children[2].children[0].children[1].children[1].material = new THREE.MeshBasicMaterial(
              { color: 0x00c2ff, transparent: true, opacity: 0 }
            ); //Inside Head

            object.children[2].children[0].scale.x = 1.2;
            object.children[2].children[0].scale.y = 1.2;
            object.children[2].children[0].scale.z = 1.2;

            var map3 = new THREE.TextureLoader().load("call3.png");
            var photomat3 = new THREE.SpriteMaterial({
              map: map3,
              color: 0xffffff,
            });
            var sprite3 = new THREE.Sprite(photomat3);
            sprite3.position.set(-800, 0, -1300);
            sprite3.scale.set(2560, 1440, 1);
            sprite3.material.transparent = true;
            sprite3.material.opacity = 0.4;

            // 2nd Triangle Page Boxes
            function triangle(hsize, posx, posy, posz, colorW) {
              var linem = new THREE.LineBasicMaterial({
                color: colorW,
              });

              var pnts = [];
              pnts.push(new THREE.Vector3(-hsize, -hsize, -hsize)); //x,y,z
              pnts.push(new THREE.Vector3(hsize, -hsize, -hsize));
              pnts.push(new THREE.Vector3(hsize, -hsize, hsize));
              pnts.push(new THREE.Vector3(-hsize, -hsize, hsize));
              pnts.push(new THREE.Vector3(-hsize, -hsize, -hsize));
              pnts.push(new THREE.Vector3(0, hsize * 2, 0));
              pnts.push(new THREE.Vector3(hsize, -hsize, hsize));
              pnts.push(new THREE.Vector3(-hsize, -hsize, hsize));
              pnts.push(new THREE.Vector3(0, hsize * 2, 0));
              pnts.push(new THREE.Vector3(hsize, -hsize, -hsize));

              var lineg = new THREE.BufferGeometry().setFromPoints(pnts);

              var line = new THREE.Line(lineg, linem);
              load.scene.add(line);
              line.position.x = posx;
              line.position.z = posz;
              line.position.y = posy;
            }

            triangle(20, -1205, 10, -250, 0x8b8b8b);
            triangle(20, -920, 10, 60, 0x8b8b8b);
            triangle(20, -1340, 10, 100, 0x8b8b8b);

            // 2nd Page lines
            function lines(hsize, posx, posy, posz, colorW, rotate) {
              var linem = new THREE.LineBasicMaterial({
                color: colorW,
              });

              var sphm = new THREE.MeshBasicMaterial({
                color: colorW,
              });

              var pnts = [];
              pnts.push(new THREE.Vector3(-hsize, -hsize, -hsize)); //x,y,z
              pnts.push(new THREE.Vector3(0, -hsize, -hsize));
              pnts.push(new THREE.Vector3(hsize, -hsize, -hsize));
              pnts.push(new THREE.Vector3(hsize * 2, -hsize, -hsize));
              pnts.push(new THREE.Vector3(hsize * 3, -hsize, -hsize));
              pnts.push(new THREE.Vector3(hsize * 4, -hsize, 0));
              pnts.push(new THREE.Vector3(hsize * 5, -hsize, hsize));
              pnts.push(new THREE.Vector3(hsize * 6, -hsize, hsize * 2));
              pnts.push(new THREE.Vector3(hsize * 7, -hsize, hsize * 2));
              pnts.push(new THREE.Vector3(hsize * 8, -hsize, hsize * 2));
              pnts.push(new THREE.Vector3(hsize * 9, -hsize, hsize * 2));

              var lineg = new THREE.BufferGeometry().setFromPoints(pnts);
              var sphg = new THREE.SphereGeometry(1, 32, 32);

              var line = new THREE.Line(lineg, linem);
              // var sphe = new THREE.Line( sphg, sphm );
              load.scene.add(line);
              line.position.x = posx;
              line.position.z = posz;
              line.position.y = posy;

              line.rotation.y = rotate;

              for (var w = 0; w < pnts.length; w++) {
                var sphere = new THREE.Mesh(sphg, sphm);
                line.add(sphere);
                sphere.position.x = pnts[w].x;
                sphere.position.z = pnts[w].z;
                sphere.position.y = pnts[w].y;

                sphere.scale.y = 0.5;
                sphere.scale.x = 0.5;
                sphere.scale.z = 0.5;
              }
            }

            lines(10, -1310, 40, 150, 0x00c2ff, 0); //left
            lines(35, -1170, 60, 90, 0x00c2ff, 1.9); //center
            lines(19, -1000, 40, 85, 0x00c2ff, 3.8); //right

            //Page3
            object.children[4].children[0].children[0].children[0].material = new THREE.MeshBasicMaterial(
              { color: 0x00c2ff }
            ); //Flying drone
            for (var flydro = 1; flydro < 5; flydro++) {
              object.children[4].children[
                flydro
              ].children[0].children[0].children[0].material = new THREE.MeshBasicMaterial(
                { color: 0x00c2ff }
              ); //Flying drone
            }

            //Page4

            for (var coin = 0; coin < 3; coin++) {
              object.children[1].children[
                coin
              ].children[0].children[0].children[0].material = new THREE.MeshBasicMaterial(
                { color: 0x00c2ff }
              ); //Coins
            }

            object.children[1].children[5].children[0].material = new THREE.MeshBasicMaterial(
              { color: 0xc9c9c9 }
            ); //circle around

            object.children[1].children[4].children[0].material = new THREE.MeshBasicMaterial(
              { color: 0xc9c9c9 }
            );

            var map2 = new THREE.TextureLoader().load("invest2.png");
            var photomat2 = new THREE.SpriteMaterial({
              map: map2,
              color: 0xffffff,
            });
            var sprite2 = new THREE.Sprite(photomat2);
            sprite2.position.set(400, -40, -1300);
            sprite2.scale.set(2048, 1024, 1);
            sprite2.material.transparent = true;
            sprite2.material.opacity = 0.3;

            for (var c = 0; c < 10; c++) {
              object.children[1].children[3].children[
                c
              ].children[0].material = new THREE.MeshBasicMaterial({
                color: 0xacf8ff,
              });
            }

            $(".dis-te").removeClass("dis-teR");
            $(".dis-te").removeClass("dis-teL");
            $(".distorted-img").removeClass("dis-teR");
            $(".distorted-img").removeClass("dis-teL");
            $(".distorted-img-corners").removeClass("dis-teR2");
            $(".distorted-img-corners").removeClass("dis-teL2");

            function pageone() {
              var zero = new TimelineMax();

              $(".title-num").html("01");

              $(".dis-te").addClass("dis-teR");
              $(".distorted-img").addClass("dis-teL");
              $(".distorted-img-corners").addClass("dis-teL2");

              zero.set(object.children[3].children[0].children[1].scale, {
                z: 0,
                x: 0,
                y: 0,
              });
              zero.set(object.children[3].children[0].children[1].position, {
                z: 0,
                x: 0,
                y: -45,
              });
              zero.set(object.children[3].children[0].children[1].rotation, {
                z: 0,
                x: 0,
                y: 0,
              });

              zero.to(
                object.children[3].children[0].children[1].scale,
                2,
                { z: 1, x: 1, y: 1 },
                0
              );
              zero.to(
                object.children[3].children[0].children[1].rotation,
                { z: 0, x: 0, y: 0 },
                0
              ); //whole cube

              object.children[3].children[1].children[0].scale.y = 0; //cube around
              object.children[3].children[1].children[0].scale.z = 0; //cube around
              object.children[3].children[1].children[0].scale.x = 0; //cube around
              zero.to(
                object.children[3].children[1].children[0].scale,
                2,
                { z: 1, x: 1, y: 1 },
                0
              ); //cube around

              load.scene.add(object);

              object.add(sprite);

              $(".next").click(function () {
                setTimeout(function () {
                  object.remove(sprite);
                }, 2000);
              });
              $(".prev").click(function () {
                setTimeout(function () {
                  object.remove(sprite);
                }, 2000);
              });
              $(".nav li").click(function () {
                setTimeout(function () {
                  object.remove(sprite);
                }, 2000);
              });
              $(".logo-text").click(function () {
                setTimeout(function () {
                  object.remove(sprite);
                }, 2000);
              });
              $(".number").click(function () {
                setTimeout(function () {
                  object.remove(sprite);
                }, 2000);
              });
              $("#menu-cover ul li").click(function () {
                setTimeout(function () {
                  object.remove(sprite);
                }, 2000);
              });

              $(".filter-name")
                .children("span")
                .text("Мне нужен Фулфилмент");
              $("form").hide();
              $(".nothing").hide();
              $("#testform").fadeIn();

              $("#click-box").show();

              $(".more-item1").hide();
              $(".more-item2").show();
              $(".more-item3").show();
              $(".more-item4").show();

              var drone = new TimelineMax();
              var droneCont = new TimelineMax();
              drone.set(object.children[3].children[0].children[0].rotation, {
                z: 0,
                x: 0,
                y: 0,
              });
              drone.set(object.children[3].children[0].children[0].position, {
                z: 0,
                x: 0,
                y: 0,
              });

              $("#click-box").mousedown(function () {
                setProgress(100);
                drone.to(
                  object.children[3].children[0].children[0].rotation,
                  { z: -0.2, x: -0.2, y: 0 },
                  0
                );
                drone.to(
                  object.children[3].children[0].children[0].position,
                  2,
                  { z: 140, x: 140, y: -205 },
                  0
                );
                drone.play();
              });

              var drontContZ = 140;
              var drontContX = 300;
              var drontContY = 20;

              var cubeContZ = 0;
              var cubeContX = 130;
              var cubeContY = 125;

              setInterval(function () {
                if (
                  object.children[3].children[0].children[0].position.x == 140
                ) {
                  setProgress(0);
                  droneCont.to(
                    object.children[3].children[0].children[0].position,
                    2,
                    { z: drontContZ, x: drontContX, y: drontContY },
                    0
                  );
                  droneCont.to(
                    object.children[3].children[0].children[1].position,
                    2,
                    { z: cubeContZ, x: cubeContX, y: cubeContY },
                    0
                  );
                  droneCont.to(
                    object.children[3].children[0].children[1].rotation,
                    2,
                    { z: 0, x: 0, y: 0.5 },
                    0
                  );
                  droneCont.to(
                    object.children[3].children[1].children[0].scale,
                    2,
                    {
                      delay: 0,
                      z: 0,
                      x: 0,
                      y: 0,
                      onComplete: function () {
                        pageone();
                      },
                    },
                    0
                  );
                  $("#click-box").hide();
                }
              }, 500);

              $("#click-box").mouseup(function () {
                setProgress(0);
                if (object.children[1].children[0].position.x >= 140) {
                  setProgress(0);
                } else {
                  drone.reverse();
                }
              });
            }

            //Page 1
            if (load.number == 0) {
              setTimeout(function () {
                pageone();
              }, 2000);
            }

            //Page 2
            else if (load.number == 1) {
              var two = new TimelineMax();
              two.set(object.children[2].children[0].rotation, { y: 20 });
              two.to(
                object.children[2].children[0].rotation,
                3,
                { delay: 1, y: 0.3 },
                0
              );

              $(".title-num").html("02");

              $(".dis-te").addClass("dis-teL");
              $(".distorted-img").addClass("dis-teR");
              $(".distorted-img-corners").addClass("dis-teR2");

              $("#video").fadeOut();

              $(".filter-name")
                .children("span")
                .text("Мне нужен Колл-центр");
              $("form").hide();
              $(".nothing").hide();
              $("#testform2").fadeIn();

              $(".more-item1").show();
              $(".more-item2").hide();
              $(".more-item3").show();
              $(".more-item4").show();

              object.add(sprite3);

              $(".next").click(function () {
                setTimeout(function () {
                  object.remove(sprite3);
                }, 2000);
              });
              $(".prev").click(function () {
                setTimeout(function () {
                  object.remove(sprite3);
                }, 2000);
              });
              $(".nav li").click(function () {
                setTimeout(function () {
                  object.remove(sprite3);
                }, 2000);
              });
              $(".logo-text").click(function () {
                setTimeout(function () {
                  object.remove(sprite3);
                }, 2000);
              });
              $(".number").click(function () {
                setTimeout(function () {
                  object.remove(sprite3);
                }, 2000);
              });
              $("#menu-cover ul li").click(function () {
                setTimeout(function () {
                  object.remove(sprite3);
                }, 2000);
              });

              $(".gradient-two").fadeOut();
              $("#click-box").hide();
            }
            //Page 3
            else if (load.number == 2) {
              $(".dis-te").addClass("dis-teR");
              $(".distorted-img").addClass("dis-teL");
              $(".distorted-img-corners").addClass("dis-teL2");

              $(".title-num").html("03");

              $(".gradient-two").fadeIn();
              $("#click-box").fadeIn();

              $(".filter-name")
                .children("span")
                .text("Мне нужен Консалтинг");
              $("form").hide();
              $(".nothing").hide();
              $("#testform3").fadeIn();

              $(".more-item1").show();
              $(".more-item2").show();
              $(".more-item3").hide();
              $(".more-item4").show();

              setTimeout(function () {
                $("#video").fadeIn(1500);
              }, 2000);

              $(".next").click(function () {
                $("#video").fadeOut(1000);
              });
              $(".prev").click(function () {
                $("#video").fadeOut(1000);
              });
              $(".nav li").click(function () {
                $("#video").fadeOut(1000);
              });
              $(".logo-text").click(function () {
                $("#video").fadeOut(1000);
              });
              $(".number").click(function () {
                $("#video").fadeOut(1000);
              });
              $("#menu-cover ul li").click(function () {
                $("#video").fadeOut(1000);
              });

              var dro = new TimelineMax();
              var dro2 = new TimelineMax();
              var speed = 0.15;
              dro2.set(object.children[4].children[1].children[0].rotation, {
                y: 0,
              }); //bot right
              dro2.set(object.children[4].children[2].children[0].rotation, {
                y: 0,
              }); //bot left
              dro2.set(object.children[4].children[3].children[0].rotation, {
                y: 0,
              }); //top left
              dro2.set(object.children[4].children[4].children[0].rotation, {
                y: 0,
              }); //top right
              dro2.to(
                object.children[4].children[1].children[0].rotation,
                speed,
                { y: 2, repeat: -1, ease: "Power0.easeIn" },
                0
              );
              dro2.to(
                object.children[4].children[2].children[0].rotation,
                speed,
                { y: -2, repeat: -1, ease: "Power0.easeIn" },
                0
              );
              dro2.to(
                object.children[4].children[3].children[0].rotation,
                speed,
                { y: 2, repeat: -1, ease: "Power0.easeIn" },
                0
              );
              dro2.to(
                object.children[4].children[4].children[0].rotation,
                speed,
                { y: -2, repeat: -1, ease: "Power0.easeIn" },
                0
              );

              $("#click-box").mousedown(function () {
                setProgress(100);
                dro.to(object.children[4].children[0].children[0].position, 2, {
                  x: -0.1,
                  ease: "Expo.linear",
                });
                dro.play();
              });

              $("#click-box").mouseup(function () {
                setProgress(0);
                if (
                  object.children[4].children[0].children[0].position.x == -0.1
                ) {
                  dro.reverse(2);
                } else {
                  dro.reverse();
                }
              });
            }
            //Page4
            else if (load.number == 3) {
              var rot = new TimelineMax();

              $(".dis-te").addClass("dis-teL");
              $(".distorted-img").addClass("dis-teR");
              $(".distorted-img-corners").addClass("dis-teR2");

              $(".title-num").html("04");

              $(".filter-name")
                .children("span")
                .text("Я инвестор");
              $("form").hide();
              $(".nothing").hide();
              $("#testform4").fadeIn();

              $("#video").fadeOut();

              rot.to(
                object.children[1].children[0].children[0].position,
                3,
                { y: -50, yoyo: true, repeat: -1, ease: "Power1.easeInOut" },
                0
              ); //coin1:middle
              rot.to(
                object.children[1].children[1].children[0].position,
                3,
                {
                  delay: 1,
                  z: -50,
                  yoyo: true,
                  repeat: -1,
                  ease: "Power1.easeInOut",
                },
                0
              ); //coin2:left
              rot.to(
                object.children[1].children[2].children[0].position,
                3,
                {
                  delay: 2,
                  y: -50,
                  yoyo: true,
                  repeat: -1,
                  ease: "Power1.easeInOut",
                },
                0
              ); //coin3:right

              rot.to(
                object.children[1].children[0].children[0].rotation,
                3,
                { z: -6.3, repeat: -1, ease: "Power0.easeIn" },
                0
              ); //coin1:middle
              rot.to(
                object.children[1].children[1].children[0].rotation,
                3,
                { x: -6.3, repeat: -1, ease: "Power0.easeIn" },
                0
              ); //coin2:left
              rot.to(
                object.children[1].children[2].children[0].rotation,
                3,
                { z: -6.3, repeat: -1, ease: "Power0.easeIn" },
                0
              ); //coin3:right

              object.add(sprite2);

              $(".more-item1").show();
              $(".more-item2").show();
              $(".more-item3").show();
              $(".more-item4").hide();

              $(".next").click(function () {
                setTimeout(function () {
                  object.remove(sprite2);
                }, 2000);
              });
              $(".prev").click(function () {
                setTimeout(function () {
                  object.remove(sprite2);
                }, 2000);
              });
              $(".nav li").click(function () {
                setTimeout(function () {
                  object.remove(sprite2);
                }, 2000);
              });
              $(".logo-text").click(function () {
                setTimeout(function () {
                  object.remove(sprite2);
                }, 2000);
              });
              $(".number").click(function () {
                setTimeout(function () {
                  object.remove(sprite2);
                }, 2000);
              });
              $("#menu-cover ul li").click(function () {
                setTimeout(function () {
                  object.remove(sprite2);
                }, 2000);
              });

              $(".gradient-two").fadeOut();
              $("#click-box").fadeOut();

              $(".next").click(function () {
                rot.reverse(0.0001);
                rot.pause(0);
              });
              $(".prev").click(function () {
                rot.reverse(0.0001);
                rot.pause(0);
              });
            }

            function next() {
              tl.reverse();
              cover.reverse(3.2);
            }

            $(".next").click(function () {
              next();
            });
            $(".prev").click(function () {
              next();
            });
            $(".nav li").click(function () {
              next();
            });
            $(".logo-text").click(function () {
              next();
            });
            $(".more-item").click(function () {
              next();
            });
            $(".number").click(function () {
              next();
            });
            $("#menu-cover ul li").click(function () {
              next();
            });

            $(".diff").click(function () {
              enableScroll();
            });
          }

          function start() {
            load.camera.position.x = -3730;
            load.camera.position.z = -150;
            load.camera.position.y = 20;
            var geometryFly = new THREE.BoxGeometry(3, 3, 70);
            var materialFly = new THREE.MeshBasicMaterial({
              color: 0x2778f3,
              opacity: 0.5,
              transparent: true,
            });
            var meshC = [];
            var fly;
            var fly2;
            var tk = new TimelineMax();
            for (fly = 0; fly < 500; fly++) {
              var mesh = new THREE.Mesh(geometryFly, materialFly);

              meshC.push(mesh);
              mesh.position.x = Math.random() * (-3850 - -3650) + -3650;
              mesh.position.y = (Math.random() - 0.5) * 120;

              tk.to(meshC[fly].position, 30, { z: -5000 }, fly * 0.3);
              load.scene.add(meshC[fly]);
            }

            document.onmousemove = function (event) {
              if (load.start == true) {
                var x = (event.clientX * 5) / window.innerWidth;
                var y = (event.clientY * 5) / window.innerHeight;
                var came = new TimelineMax();
                came.to(load.camera.position, 2, { x: -3735 + x, y: 20 - y });
              }
            };

            setInterval(function () {
              if (tk.progress() > 0.85) {
                tk.restart();
              }
            }, 700);

            for (fly2 = 0; fly2 < 30; fly2++) {
              var mesh2 = new THREE.Mesh(geometryFly, materialFly);
              mesh2.position.x = Math.random() * (-3850 - -3650) + -3650;
              mesh2.position.y = (Math.random() - 0.5) * 120;
              mesh2.position.z = Math.floor(Math.random() * -2700) + -2100;
              load.scene.add(mesh2);
            }

            var tl2 = new TimelineMax();
            $("#initial-enter").click(function () {
              $("head").append(
                "<style>#initial-enter:before{width:0; transition: 16s cubic-bezier(0, .25, .5, 1) !important;}</style>"
              );
              $("#initial-enter").addClass("anim");

              tl2.set(load.camera.position, { z: -150 });
              tl2.to(
                load.camera.position,
                4,
                {
                  z: -2500,
                  ease: "Power1.easeIn",
                },
                0
              );
              tl2.play();
            });

            var inter = setInterval(function () {
              if (load.camera.position.z <= -2000) {
                $(".welcoming").fadeOut();
                $("#container").fadeOut();

                // load.number = 0

                //before
                setTimeout(function () {
                  update(
                    array[load.number].pz,
                    array[load.number].px,
                    array[load.number].py,
                    array[load.number].rz,
                    array[load.number].rx,
                    array[load.number].ry,
                    array[load.number].pz2,
                    array[load.number].px2,
                    array[load.number].py2,
                    array[load.number].rz2,
                    array[load.number].rx2,
                    array[load.number].ry2,
                    array[load.number].mpz,
                    array[load.number].mpx,
                    array[load.number].mpy,
                    array[load.number].mpz2,
                    array[load.number].mpx2,
                    array[load.number].mpy2,
                    array[load.number].title,
                    array[load.number].subtitle,
                    array[load.number].infoTextOne,
                    array[load.number].infoTextTwo,
                    array[load.number].infoTextThree,
                    array[load.number].infoTextFour,
                    array[load.number].infoPictureOne,
                    array[load.number].infoPictureTwo,
                    array[load.number].infoPictureThree,
                    array[load.number].infoPictureFour,
                    array[load.number].Engtitle,
                    array[load.number].descr,
                    array[load.number].infoDisPicture
                  );
                }, 800);
                // after
                load.start = false;
                setTimeout(function () {
                  $(".enter").fadeIn();

                  if ($(window).width() < 900) {
                    $(".go-down").fadeIn();
                  }
                }, 1700);

                var myAudio = document.getElementById("audio");
                myAudio.play();
                myAudio.volume = 0.05;

                setTimeout(function () {
                  $("#container").fadeIn();
                  $(".next").fadeIn();
                  $(".prev").fadeIn();
                  $(".gradient").fadeIn();
                  $(".page-number").fadeIn();
                  $(".nav").fadeIn();
                  $(".menu-icon").fadeIn();
                  $(".logo-text").fadeIn();
                  tk.kill();
                }, 2700);
                clearInterval(inter);
                return false;
              }
            }, 100);
          }

          if (load.prevBool == false) {
            start();
          } else {
            update(
              array[load.number].pz,
              array[load.number].px,
              array[load.number].py,
              array[load.number].rz,
              array[load.number].rx,
              array[load.number].ry,
              array[load.number].pz2,
              array[load.number].px2,
              array[load.number].py2,
              array[load.number].rz2,
              array[load.number].rx2,
              array[load.number].ry2,
              array[load.number].mpz,
              array[load.number].mpx,
              array[load.number].mpy,
              array[load.number].mpz2,
              array[load.number].mpx2,
              array[load.number].mpy2,
              array[load.number].title,
              array[load.number].subtitle,
              array[load.number].infoTextOne,
              array[load.number].infoTextTwo,
              array[load.number].infoTextThree,
              array[load.number].infoTextFour,
              array[load.number].infoPictureOne,
              array[load.number].infoPictureTwo,
              array[load.number].infoPictureThree,
              array[load.number].infoPictureFour,
              array[load.number].Engtitle,
              array[load.number].descr,
              array[load.number].infoDisPicture
            );
          }

          $(".next").click(function () {
            if (load.number == 3) {
              load.number = 0;
            } else {
              load.number++;
            }

            switchPage();

            var width2 = new TimelineMax();
            width2.set(".timer", { width: "0vw", opacity: 1 });
            width2.to(".timer", 3, { width: "25vw", ease: "Power0.easeIn" });
          });

          $(".prev").click(function () {
            if (load.number == 0) {
              load.number = 3;
            } else {
              load.number--;
            }

            var width2 = new TimelineMax();
            width2.set(".timer", { width: "0vw", opacity: 1 });
            width2.to(".timer", 3, { width: "25vw", ease: "Power0.easeIn" });

            switchPage();
          });

          function clicking(name, num) {
            $(name).click(function () {
              load.number = num;

              var width2 = new TimelineMax();
              width2.set(".timer", { width: "0vw", opacity: 1 });
              width2.to(".timer", 3, { width: "25vw", ease: "Power0.easeIn" });

              switchPage();
            });
          }

          clicking(".ful", 0);
          clicking(".logo-text", 0);
          clicking(".call", 1);
          clicking(".cons", 2);
          clicking(".invest", 3);
          clicking(".man-ful", 0);
          clicking(".man-call", 1);
          clicking(".man-cons", 2);
          clicking(".man-invest", 3);
          clicking(".numberOne", 0);
          clicking(".numberTwo", 1);
          clicking(".numberThree", 2);
          clicking(".numberFour", 3);

          function clickingMore(name, num) {
            $(name).click(function () {
              load.number = num;

              $("html, body").animate({ scrollTop: 0 }, "fast");

              var width2 = new TimelineMax();
              width2.set(".timer", { width: "0vw", opacity: 1 });
              width2.to(".timer", 3, { width: "25vw", ease: "Power0.easeIn" });

              t.pause(0);

              switchPage();
            });
          }

          clickingMore(".more-item1", 0);
          clickingMore(".more-item2", 1);
          clickingMore(".more-item3", 2);
          clickingMore(".more-item4", 3);

          function closeDetails(name) {
            $(name).click(function () {
              $("html, body").animate({ scrollTop: 0 }, "fast");
              $(".menu-icon").fadeIn();

              t.reverse();
            });
          }

          closeDetails(".close-details");

          function changeInNumber(name) {
            function insideClicking() {
              $(".page-number .number").removeClass("current-number");
              $(".nav li").removeClass("current-page");

              if (load.number == 0) {
                $(".page-number .numberOne").addClass("current-number");
                $(".ful").addClass("current-page");
              } else if (load.number == 1) {
                $(".page-number .numberTwo").addClass("current-number");
                $(".call").addClass("current-page");
              } else if (load.number == 2) {
                $(".page-number .numberThree").addClass("current-number");
                $(".cons").addClass("current-page");
              } else if (load.number == 3) {
                $(".page-number .numberFour").addClass("current-number");
                $(".invest").addClass("current-page");
              }
            }

            $(name).click(function () {
              insideClicking();
            });
            $(document).ready(function () {
              insideClicking();
            });
          }

          changeInNumber(".nav li");
          changeInNumber(".logo-text");
          changeInNumber("#menu-cover ul li");
          changeInNumber(".next");
          changeInNumber(".prev");
          changeInNumber(".more-item");
          changeInNumber(".more-item .angle");
          changeInNumber(".number");

          console.log(object);
          load.scene.add(object);
        },
        function (xhr) {
          var paceN = Math.floor((xhr.loaded / xhr.total) * 100);
          paceN = Math.floor((xhr.loaded / xhr.total) * 100);
          $(".pace-n").html(paceN + "%");
          if (paceN == 100) {
            setTimeout(function () {
              $(".pace").fadeOut();
              setTimeout(function () {
                $(".welcoming").animate({ opacity: 1 }, 700);
              }, 700);
            }, 700);
          }
        },
        undefined,
        function (error) {
          console.error(error);
        }
      );

      this.controls.update();
      this.controls.enabled = false;
    },
    animate: function () {
      requestAnimationFrame(this.animate);
      this.renderer.render(this.scene, this.camera);
    },
    someMethod() {
      this.$router.push("/welcoming");
    },
  },
  mounted() {
    var th = this;

    function callingMethods() {
      th.init();
      th.animate();
    }

    if (this.$route.name == "home2") {
      callingMethods();
    }

    window.addEventListener("unload", this.someMethod);

    $(".active").mouseover(function () {
      $(".cursor").css("transform", "translate(-50%, -50%) scale(2)");
    });
    $(".active").mouseleave(function () {
      $(".cursor").css("transform", "translate(-50%, -50%) scale(1)");
    });
  },
  destroyed() {
    this.renderer.forceContextLoss();
  },
};
</script>

<style scoped>
.scroll-down {
  position: absolute;
  background-image: url("../assets/arrow.svg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  width: 30px;
  height: 30px;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%) rotate(-90deg);
  animation-name: scrollDown;
  animation-duration: 3s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  display: none;
  opacity: 0;
}

@keyframes scrollDown {
  0% {
    bottom: 30px;
  }

  50% {
    bottom: 40px;
  }

  100% {
    bottom: 30px;
  }
}

.anim::before {
  animation-name: cssAnimation;
  animation-duration: 4s;
  animation-timing-function: linear;
}

@keyframes cssAnimation {
  from {
    width: 80%;
  }

  to {
    width: 0;
  }
}

.close-details {
  position: fixed;
  top: 30px;
  right: 30px;
  width: 35px;
  height: 35px;
  background-image: url("../assets/close.svg");
  background-size: 50%;
  background-position: 50% 53%;
  background-repeat: no-repeat;
  display: none;
  opacity: 0;
  border: white solid 2px;
  border-radius: 50%;
  z-index: 10;
}

.title-wrap2 {
  position: relative;
  margin-left: 20px;
}

.title-num {
  position: absolute;
  top: 0;
  left: -20%;
}

.wrap-under p {
  width: 25vw;
  margin-top: 25px;
  margin-left: 20px;
  position: relative;
}

.wrap-under {
  position: absolute;
  left: 10%;
  top: 50%;
  transform: translateY(-50%);
  /* display: non; */
}

.enter22 {
  text-align: center;
  background-color: #2778f3;
  padding: 8px;
  width: 14vw;
  /* font-size: 14px; */
  font-size: calc(0.7vw + 0.6vh + 0.5vmin);
  color: white;
  text-decoration: none;
  position: relative;
  margin-top: 30px;
  margin-left: 20px;
  display: none;
}

.contact-title {
  margin-top: 200px;
  margin-bottom: 100px;
  display: inline-block;
}

.contact-par {
  width: 35%;
  float: right;
  margin-top: 230px;
  margin-right: 20%;
  display: inline-block;
}

.more-decr {
  margin-top: 20vw;
}

.more-decr h1 {
  font-size: 1.5em;
}

.more-decr h6 {
  margin-top: 10px;
  font-weight: 100;
  font-size: 0.9em;
  padding-right: 20px;
  line-height: 23px;
}

.distorted-more-img {
  background-size: cover;
  background-position: right center;
  filter: grayscale(1);
  height: 90%;
  width: 90%;
  margin: 0 auto;
  position: absolute;
  top: 50%;
  transform: translateY(-50%) scale(0.9);
  transition: 0.3s;
}

.distorted-more-img:hover {
  transform: translateY(-50%) scale(1);
  filter: grayscale(0);
}

.distorted-more-corners {
  height: 90%;
  width: 90%;
  background: linear-gradient(to right, #739fac 1px, transparent 1px) 0 0,
    linear-gradient(to right, #739fac 1px, transparent 1px) 0 100%,
    linear-gradient(to left, #739fac 1px, transparent 1px) 100% 0,
    linear-gradient(to left, #739fac 1px, transparent 1px) 100% 100%,
    linear-gradient(to bottom, #739fac 1px, transparent 1px) 0 0,
    linear-gradient(to bottom, #739fac 1px, transparent 1px) 100% 0,
    linear-gradient(to top, #739fac 1px, transparent 1px) 0 100%,
    linear-gradient(to top, #739fac 1px, transparent 1px) 100% 100%,
    linear-gradient(to top, #739fac 1px, transparent 1px) 100% 100%;
  background-repeat: no-repeat;
  background-size: 40px 40px;
  z-index: 2;
  position: absolute;
  pointer-events: none;
  margin: 1vw auto;
}

.more-cover {
  height: 100%;
  width: 80vw;
  margin-left: calc(10vw + 1%);
  margin-top: 50px;
  margin-bottom: 120px;
}

.more-info {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}

.more-info .more-item {
  height: 20vw;
  position: relative;
}

.more-item1 .distorted-more-img {
  background-image: url("../assets/more-ful.png");
}

.more-item2 .distorted-more-img {
  background-image: url("../assets/more-call.png");
}

.more-item3 .distorted-more-img {
  background-image: url("../assets/more-cons.png");
}

.more-item4 .distorted-more-img {
  background-image: url("../assets/more-invest.png");
}

.morePages {
  margin-top: 50px;
}

.distorted-text {
  height: 100vh;
  position: relative;
}

.reload {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.reload a {
  text-decoration: underline;
  opacity: 0.7;
}

.dis-te {
  position: absolute;
  right: 10%;
  bottom: 10%;
  width: 30%;
  z-index: 1;
}

.dis-teR {
  right: 10% !important;
  left: unset !important;
}

.dis-teR2 {
  right: 9% !important;
  left: unset !important;
}

.dis-teL {
  left: 10% !important;
  right: unset !important;
}

.dis-teL2 {
  left: 9% !important;
  right: unset !important;
}

.dis-te h2,
.dis-te h4 {
  font-weight: 100;
}

.dis-te h2 {
  font-size: 2em;
  border-bottom: #2778f3 3px solid;
  display: inline-block;
  margin-bottom: 15px;
}

.dis-te h4 {
  line-height: 36px;
}

.distorted-img-corners {
  height: 31.5vw;
  width: 62vw;
  position: absolute;
  top: 50%;
  left: 9%;
  transform: translateY(-50%);
  background: linear-gradient(to right, #739fac 1px, transparent 1px) 0 0,
    linear-gradient(to right, #739fac 1px, transparent 1px) 0 100%,
    linear-gradient(to left, #739fac 1px, transparent 1px) 100% 0,
    linear-gradient(to left, #739fac 1px, transparent 1px) 100% 100%,
    linear-gradient(to bottom, #739fac 1px, transparent 1px) 0 0,
    linear-gradient(to bottom, #739fac 1px, transparent 1px) 100% 0,
    linear-gradient(to top, #739fac 1px, transparent 1px) 0 100%,
    linear-gradient(to top, #739fac 1px, transparent 1px) 100% 100%;
  background-repeat: no-repeat;
  background-size: 40px 40px;
  z-index: 1;
  pointer-events: none;
}

.distorted-img {
  background-size: cover;
  height: 30vw;
  width: 60vw;
  position: absolute;
  top: 50%;
  left: 10%;
  transform: translateY(-50%) scale(1);
  transition: 0.3s;
}

.distorted-img:hover {
  transform: translateY(-50%) scale(1.03);
}

.bg-grid {
  height: 100%;
  background-image: url("../assets/grid.png");
  background-size: cover;
  position: relative;
  pointer-events: none;
}

.moreInfo {
  margin-top: 50px;
  display: none;
}

.info {
  margin-left: calc(10vw + 20px);
  transform: translateY(0%);
}

.grid-cover {
  height: 100%;
  width: 80vw;
  margin-left: calc(10vw + 20px);
  margin-top: 50px;
  margin-bottom: 120px;
}

.grid-info {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
}

.grid-info .item {
  height: 175px;
  transform: translateY(-20%);
  opacity: 0;
  /* border: 1px solid red; */
}

.grid-info .item:nth-child(2n) {
  transform: translateY(50%);
}

.grid-info .item p {
  width: 55%;
  float: right;
  display: inline-block;
  padding-top: 20px;
}

.itemPicture {
  height: 100%;
  width: 40%;
  background-position: right center;
  background-repeat: no-repeat;
  background-size: auto 70%;
  display: inline-block;
}

.whole {
  height: 100vh;
  display: none;
}

.welcoming,
.welcomingMobile {
  display: flex;
  height: 100vh;
  flex-direction: column;
  opacity: 0;
}

.welcomingMobile {
  opacity: unset;
}

.logo-icon {
  margin-top: 30vh;
  height: 8%;
  margin-bottom: 0px;
  position: relative;
}

.logo-text2 {
  height: 3.5%;
  position: relative;
}

br {
  display: block;
  margin: 10px;
}

h3 {
  font-weight: normal;
  text-align: center;
  letter-spacing: 0.02em;
  font-size: calc(0.8vw + 0.7vh + 0.5vmin);
  margin-top: 2vh;
  position: relative;
}

.welcoming h3 br {
  margin: 1px;
}

.enter {
  text-align: center;
  background-color: #2778f3;
  padding: 8px;
  width: 8vw;
  font-size: calc(0.7vw + 0.6vh + 0.5vmin);
  color: white;
  text-decoration: none;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 5vh;
  position: relative;
  user-select: none;
}

#initial-enter {
  transition: unset !important;
}

.shadow {
  background-image: url("../assets/shadow.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  width: 70vw;
  height: 70vh;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
}

.timer {
  position: absolute;
  bottom: 45px;
  height: 7px;
  width: 0px;
  left: 10vw;
  background-color: #2778f3;
}

video {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  border: 0;
  object-fit: cover;
  object-position: 40px;
}

.gradient-two {
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-image: url("../assets/shade2.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: none;
  pointer-events: none;
}

.prev,
.next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 30px;
  width: 40px;
  height: 40px;
  background-image: url("../assets/arrow.svg");
  background-size: contain;
  cursor: pointer;
  z-index: 3;
  display: none;
}

.next {
  left: unset;
  right: 30px;
  transform: translateY(-50%) rotate(180deg);
}

#click-box {
  position: absolute;
  left: 40vw;
  top: 10vh;
  width: 50vw;
  height: 75vh;
  z-index: 2;
  display: none;
}

.loading {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  transform: scale(1.1);
}

.logo-text {
  width: 13vw;
  position: absolute;
  top: 30px;
  left: 30px;
  display: none;
}

.nav {
  position: absolute;
  left: 20vw;
  top: 30px;
  display: none;
  width: 74vw;
}

.nav li {
  font-size: calc(0.6vw + 0.5vh + 0.5vmin);
  display: inline-block;
  padding: 0 15px;
  color: #dedede;
  opacity: 0.5;
  cursor: pointer;
  transition: 0.3s;
}

.nav li:hover {
  color: white;
  opacity: 1;
}

.contacts {
  float: right;
  text-transform: capitalize;
  font-family: Montserrat-SemiBold;
  color: white;
  opacity: 1 !important;
}

#container {
  position: absolute;
  top: 0;
  overflow: hidden;
  outline: 0;
}

canvas:focus,
#container:focus {
  outline: 0;
}

.more-item .angle,
.contact-mobile {
  display: none;
}

@keyframes alpha {
  0% {
    opacity: 0;
  }

  90% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

#mobile {
  display: none;
}

@media only screen and (max-width: 900px) {
  #desktop {
    display: none;
  }

  #mobile {
    display: block;
  }
}
</style>
